import { SHOES_BASE_SIZES, VANESSA_LIMITS } from "../constants/modal";
import { Size } from "../types/sizes";

const filterSizes = (sizes: Size[], min: number, max: number) =>
  sizes.filter((s) => s.male >= min && s.male <= max);

export const vanessaSizesList = SHOES_BASE_SIZES.map((group) => {
  const limits = VANESSA_LIMITS[group.name as keyof typeof VANESSA_LIMITS];

  if (!limits) return group;

  return {
    ...group,
    sizes: filterSizes(group.sizes, limits.min, limits.max),
  };
});

export const getCurrencySymbol = (currency: string): string => {
  try {
    return (
      new Intl.NumberFormat("en", {
        style: "currency",
        currency,
      })
        .formatToParts(0)
        .find((part) => part.type === "currency")?.value || currency
    );
  } catch {
    return currency;
  }
};
